import { styled } from '../../styles';
import { Typography } from '../Typography';

export const AccordionTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text1,
}));

export const AccordionText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text2,
}));
